import { Form } from "react-bootstrap";

const UploadMultiFiles = ({ handleFileChange }) => {
  return (
    <Form.Group className="mb-1">
      <Form.Label className="mb-1 fw-bold">
        Upload File
        <abbr title="Required" className="text-danger">
          *
        </abbr>
      </Form.Label>
      <Form.Control
        required
        type="file"
        multiple
        accept=".csv, .txt, .rtf, .zip, .xpt, .png, .jpg, .jpeg, .xls, .xlsx, .pdf, .doc, .docx, .ppt, .pptx"
        onChange={handleFileChange}
        placeholder="Upload file"
        style={{ fontSize: 12 }}
      />
    </Form.Group>
  );
};

export default UploadMultiFiles;
